import script from "./DemandManager.vue?vue&type=script&setup=true&lang=js"
export * from "./DemandManager.vue?vue&type=script&setup=true&lang=js"

import "./DemandManager.vue?vue&type=style&index=0&id=70c08b2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c08b2b"]])

export default __exports__